import { PersistentStorage } from "./persistent-storage";
import { userSessionKey } from "./user-session-key";

export const IS_USER_AUTHENTICATED = userSessionKey("authenticated-entry");

export const MONITOR_STATUS_DRAWER_SCROLL_INDICATOR = userSessionKey("scroll-indicator");

export const MAIN_MENU_TERTIARY_ENTRIES_EXPANDED = userSessionKey("main-menu-tertiary-entries-expanded");

export const LOGIN_REDIRECT_DEEP_LINK_HASH = "login-redirect-deep-link-hash";

export const DASHBOARD_SAVE_ALERT_DISMISSED = userSessionKey("dashboard-save-alert-dismissed");

export const UNSAVED_DASHBOARD_PREFIX = userSessionKey("unsaved-dashboard-");

export const LocalStorage = new PersistentStorage(localStorage);
